import { Room } from 'src/app/shared/models/room.model';
import { ROOM_POSITION_MAP, ROOM_TYPE_MAP, RoomFilterCriteria } from 'src/app/modules/booking/components/filter-rooms/filter-rooms.models';

export function filterRoomsByFeatures(rooms: Room[], criteria: RoomFilterCriteria): Room[] {
  if (!criteria.roomConfiguration && !criteria.roomFeature) {
    return rooms;
  }

  return rooms.filter((room) => {
    if (criteria.roomConfiguration) {
      const allowedViews = ROOM_POSITION_MAP[criteria.roomConfiguration];
      const roomViews = (room.price?.options || []).map(
        (option) => option.charAt(0).toUpperCase() + option.slice(1)
      );

      if (!allowedViews.some((view) => roomViews.includes(view))) {
        return false;
      }
    }

    if (criteria.roomFeature) {
      const requiredSubtype = ROOM_TYPE_MAP[criteria.roomFeature];
      if (room.price?.productSubtype?.toLowerCase() !== requiredSubtype.toLowerCase()) {
        return false;
      }
    }

    return true;
  });
}
